import React from "react";
import ReactDOM from "react-dom/client";
import {App} from "./app/App";
import {initializeAnalytics} from "./lib/analytics";
import {setupAxiosInterceptors} from "./lib/axios";
import {initDatadog} from "./lib/datadog";
import {processTokenFromUrl} from "./lib/search-params";
import "./main.css";

initDatadog();
processTokenFromUrl();
setupAxiosInterceptors();

const container = document.getElementById("root");

if (!container) {
    throw new Error("Failed to find the root element");
}

const root = ReactDOM.createRoot(container);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

initializeAnalytics();
